import styled, { css } from 'styled-components'

import { BuyPremiumIcon } from '@root/entities/premium/ui'
import { useBreakpoint } from '@root/shared/hooks'
import { useTranslation } from '@root/shared/localization'
import { mediaMinTablet } from '@root/shared/ui-kit'

import { CheckCurrency } from './check-currency'
import { CheckCurrencyFooter } from './check-currency-footer'

import type { CurrencySafetyCheck } from '@root/features/premium'

type Props = {
  result: CurrencySafetyCheck
}

export const CheckCurrencyActive: React.FC<Props> = ({ result }) => {
  const { t } = useTranslation()

  const breakpoint = useBreakpoint()
  const isMobile = breakpoint === 'mobile'

  return (
    <>
      <CheckCurrency result={result} />
      <Footer>
        <BuyPremiumIcon
          product="boosters"
          size={isMobile ? 24 : 20}
          sizeIcon={isMobile ? 16 : 10}
        />
        {t('premium.check.note.active')}
      </Footer>
    </>
  )
}

const Footer = styled(CheckCurrencyFooter)`
  ${mediaMinTablet(css`
    margin-top: 16px;
  `)}
`
